import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2.4a.6.6 0 0 1 .6.6v10.552l3.976-3.976a.6.6 0 0 1 .848.848l-5 5a.6.6 0 0 1-.848 0l-5-5a.6.6 0 0 1 .848-.848l3.976 3.976V3a.6.6 0 0 1 .6-.6Zm-9 12a.6.6 0 0 1 .6.6v1.2c0 .85 0 1.451.039 1.922.038.463.11.745.222.968a2.4 2.4 0 0 0 1.05 1.048c.222.114.504.185.967.223.47.038 1.072.039 1.922.039h8.4c.85 0 1.451 0 1.921-.039.464-.038.746-.11.969-.223a2.4 2.4 0 0 0 1.048-1.048c.113-.223.185-.505.223-.968.038-.47.039-1.072.039-1.922V15a.6.6 0 1 1 1.2 0v1.226c0 .818 0 1.469-.043 1.993-.044.538-.136.996-.35 1.415a3.6 3.6 0 0 1-1.573 1.574c-.42.213-.878.305-1.415.35-.525.042-1.175.042-1.993.042H7.774c-.818 0-1.469 0-1.993-.043-.538-.044-.996-.136-1.415-.35a3.6 3.6 0 0 1-1.574-1.573c-.213-.42-.305-.877-.35-1.415-.042-.524-.042-1.175-.042-1.993V15a.6.6 0 0 1 .6-.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
